export enum RouteTotalStatusEnum {
  Unassigned = 'unassigned',
  InMarket = 'inMarket',
  Assigned = 'assigned',
  Started = 'started',
  Canceled = 'canceled',
  Completed = 'completed',
  Deleted = 'deleted',
  Suggestion = 'suggestion'
}
